import {
  DashboardWidgetId,
  type DashboardWidgetSettings,
} from "@/lib/types/dashboard-widgets";

/**
 * Hide private-lesson widgets while the studio module is off.
 * Saved layout rows stay intact so the widget returns in the same place.
 */
export function withoutDisabledModuleWidgets(
  layouts: DashboardWidgetSettings,
  features: { appointmentsEnabled: boolean },
): DashboardWidgetSettings {
  if (features.appointmentsEnabled) return layouts;

  const next: DashboardWidgetSettings = {};
  for (const role of Object.keys(layouts)) {
    const layout = layouts[role];
    next[role] = {
      kpiWidgets: layout.kpiWidgets,
      regularWidgets: layout.regularWidgets.filter(
        (widgetId) => widgetId !== DashboardWidgetId.PrivateLessonsCalendar,
      ),
    };
  }
  return next;
}
